import React, { useState } from "react";
import PropTypes from "prop-types";
import TreeNode from "../../../../models/TreeNode";
import FilterComponent from "./FilterComponent";
import CheckboxCategory from "./CheckboxCategory";
import Filter from "../../../../models/Filter";
import CollapseButton from "./CollapseButton";

function FilterNode({ node, level, ...rest }) {
  const sumFn = (a, i) => (i === null ? null : a + i);
  const [isCollapsed, setIsCollapsed] = useState(level > 1);
  const { childrenNodes } = node;
  const isNotCheckbx = node.findAnyData((data) => data.type !== "checkbox");
  const hasSub = Boolean(childrenNodes.length);
  const nodes = isCollapsed ? [] : childrenNodes;
  const toggle = () => setIsCollapsed(!isCollapsed);

  const subFilters = node.getDescendants();
  const totalCount = subFilters.map((x) => x.totalCount).reduce(sumFn, 0);
  const isAnyVisible = Boolean(subFilters.find((x) => x.isVisible));
  const shouldRender = isAnyVisible || totalCount;

  return shouldRender ? (
    <>
      <div className="tw-capitalize tw-relative">
        <CollapseButton
          isCollapsed={isCollapsed}
          isVisible={hasSub}
          toggle={toggle}
        />
        {isNotCheckbx ? node.id : <CheckboxCategory {...rest} node={node} />}
      </div>
      <div className="tw-pl-2">
        {nodes.map((n) =>
          n.childrenNodes?.length ? (
            <FilterNode level={level + 1} key={n.id} {...rest} node={n} />
          ) : (
            <FilterComponent
              key={n.id}
              {...rest}
              filter={n.data}
              parent={node}
            />
          )
        )}
      </div>
    </>
  ) : null;
}

FilterNode.propTypes = {
  label: PropTypes.string,
  filter: PropTypes.instanceOf(Filter),
  level: PropTypes.number.isRequired,
  node: PropTypes.instanceOf(TreeNode).isRequired,
};

FilterNode.defaultProps = {
  label: "",
  filter: null,
};

export default FilterNode;
